import "../assets/styles/App.css";
import React, { useState, useEffect, useRef } from "react";
import QRCode from "react-qr-code";
import ProfileSelect from "../components/ProfileSelect";
import axios from "axios";
import "../assets/styles/webticket.css";
import { useSearchParams } from "react-router-dom";
import poster from "../assets/images/poster.jpeg";

async function downScaleImage(img, size, s1, s2) {
  return new Promise((resolve, reject) => {
    // https://stackoverflow.com/a/19144434
    // image, wanted size, x, y, width, height(window)
    var imgCV = document.createElement("canvas");

    let s3,
      s4 = 0;
    loadImageProcess(img).then((img) => {
      s3 = img.width;
      s4 = img.height;

      imgCV.width = s3;
      imgCV.height = s4;

      var imgCtx = imgCV.getContext("2d");
      imgCtx.drawImage(img, s1, s2, s3, s4, 0, 0, s3, s4);
      const scale = s3 > s4 ? size / s3 : size / s4;

      if (scale >= 1) {
        console.log(imgCV);
        resolve(imgCV);
      } else {
        downScaleCanvas(imgCV, scale, resolve);
      }
    });
  });
}

function loadImageProcess(src) {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}
async function downScaleCanvas(cv, scale, resolve) {
  // scales the canvas by (float) scale < 1
  // returns a new canvas containing the scaled image.
  if (!(scale < 1) || !(scale > 0)) throw "scale must be a positive number <1 ";
  scale = normaliseScale(scale);
  var sqScale = scale * scale; // square scale =  area of a source pixel within target
  var sw = cv.width; // source image width
  var sh = cv.height; // source image height
  var tw = Math.floor(sw * scale); // target image width
  var th = Math.floor(sh * scale); // target image height
  var sx = 0,
    sy = 0,
    sIndex = 0; // source x,y, index within source array
  var tx = 0,
    ty = 0,
    yIndex = 0,
    tIndex = 0; // target x,y, x,y index within target array
  var tX = 0,
    tY = 0; // rounded tx, ty
  var w = 0,
    nw = 0,
    wx = 0,
    nwx = 0,
    wy = 0,
    nwy = 0; // weight / next weight x / y
  // weight is weight of current source point within target.
  // next weight is weight of current source point within next target's point.
  var crossX = false; // does scaled px cross its current px right border ?
  var crossY = false; // does scaled px cross its current px bottom border ?
  var sBuffer = cv.getContext("2d").getImageData(0, 0, sw, sh).data; // source buffer 8 bit rgba
  var tBuffer = new Float32Array(3 * tw * th); // target buffer Float32 rgb
  var sR = 0,
    sG = 0,
    sB = 0; // source's current point r,g,b
  for (sy = 0; sy < sh; sy++) {
    ty = sy * scale; // y src position within target
    tY = 0 | ty; // rounded : target pixel's y
    yIndex = 3 * tY * tw; // line index within target array
    crossY = tY !== (0 | (ty + scale));
    if (crossY) {
      // if pixel is crossing botton target pixel
      wy = tY + 1 - ty; // weight of point within target pixel
      nwy = ty + scale - tY - 1; // ... within y+1 target pixel
    }
    for (sx = 0; sx < sw; sx++, sIndex += 4) {
      tx = sx * scale; // x src position within target
      tX = 0 | tx; // rounded : target pixel's x
      tIndex = yIndex + tX * 3; // target pixel index within target array
      crossX = tX !== (0 | (tx + scale));
      if (crossX) {
        // if pixel is crossing target pixel's right
        wx = tX + 1 - tx; // weight of point within target pixel
        nwx = tx + scale - tX - 1; // ... within x+1 target pixel
      }
      sR = sBuffer[sIndex]; // retrieving r,g,b for curr src px.
      sG = sBuffer[sIndex + 1];
      sB = sBuffer[sIndex + 2];
      if (!crossX && !crossY) {
        // pixel does not cross
        // just add components weighted by squared scale.
        tBuffer[tIndex] += sR * sqScale;
        tBuffer[tIndex + 1] += sG * sqScale;
        tBuffer[tIndex + 2] += sB * sqScale;
      } else if (crossX && !crossY) {
        // cross on X only
        w = wx * scale;
        // add weighted component for current px
        tBuffer[tIndex] += sR * w;
        tBuffer[tIndex + 1] += sG * w;
        tBuffer[tIndex + 2] += sB * w;
        // add weighted component for next (tX+1) px
        nw = nwx * scale;
        tBuffer[tIndex + 3] += sR * nw;
        tBuffer[tIndex + 4] += sG * nw;
        tBuffer[tIndex + 5] += sB * nw;
      } else if (!crossX && crossY) {
        // cross on Y only
        w = wy * scale;
        // add weighted component for current px
        tBuffer[tIndex] += sR * w;
        tBuffer[tIndex + 1] += sG * w;
        tBuffer[tIndex + 2] += sB * w;
        // add weighted component for next (tY+1) px
        nw = nwy * scale;
        tBuffer[tIndex + 3 * tw] += sR * nw;
        tBuffer[tIndex + 3 * tw + 1] += sG * nw;
        tBuffer[tIndex + 3 * tw + 2] += sB * nw;
      } else {
        // crosses both x and y : four target points involved
        // add weighted component for current px
        w = wx * wy;
        tBuffer[tIndex] += sR * w;
        tBuffer[tIndex + 1] += sG * w;
        tBuffer[tIndex + 2] += sB * w;
        // for tX + 1; tY px
        nw = nwx * wy;
        tBuffer[tIndex + 3] += sR * nw;
        tBuffer[tIndex + 4] += sG * nw;
        tBuffer[tIndex + 5] += sB * nw;
        // for tX ; tY + 1 px
        nw = wx * nwy;
        tBuffer[tIndex + 3 * tw] += sR * nw;
        tBuffer[tIndex + 3 * tw + 1] += sG * nw;
        tBuffer[tIndex + 3 * tw + 2] += sB * nw;
        // for tX + 1 ; tY +1 px
        nw = nwx * nwy;
        tBuffer[tIndex + 3 * tw + 3] += sR * nw;
        tBuffer[tIndex + 3 * tw + 4] += sG * nw;
        tBuffer[tIndex + 3 * tw + 5] += sB * nw;
      }
    } // end for sx
  } // end for sy
  // create result canvas
  var resCV = document.createElement("canvas");
  resCV.width = tw;
  resCV.height = th;
  var resCtx = resCV.getContext("2d");
  var imgRes = resCtx.getImageData(0, 0, tw, th);
  var tByteBuffer = imgRes.data;
  // convert float32 array into a UInt8Clamped Array
  var pxIndex = 0; //
  for (
    sIndex = 0, tIndex = 0;
    pxIndex < tw * th;
    sIndex += 3, tIndex += 4, pxIndex++
  ) {
    tByteBuffer[tIndex] = 0 | tBuffer[sIndex];
    tByteBuffer[tIndex + 1] = 0 | tBuffer[sIndex + 1];
    tByteBuffer[tIndex + 2] = 0 | tBuffer[sIndex + 2];
    tByteBuffer[tIndex + 3] = 255;
  }
  // writing result to canvas.
  resCtx.putImageData(imgRes, 0, 0);
  resolve(resCV);
}
function log2(v) {
  // taken from http://graphics.stanford.edu/~seander/bithacks.html
  var b = [0x2, 0xc, 0xf0, 0xff00, 0xffff0000];
  var S = [1, 2, 4, 8, 16];
  var i = 0,
    r = 0;
  for (i = 4; i >= 0; i--) {
    if (v & b[i]) {
      v >>= S[i];
      r |= S[i];
    }
  }
  return r;
}
function normaliseScale(s) {
  if (s > 1) throw "s must be <1";
  s = 0 | (1 / s);
  var l = log2(s);
  var mask = 1 << l;
  var accuracy = 4;
  while (accuracy && l) {
    l--;
    mask |= 1 << l;
    accuracy--;
  }
  return 1 / (s & mask);
}

function Hapjeong2025Ticket() {
  // useSearchParams and get ticketId
  const [searchParams] = useSearchParams();
  const [ticketId, setTicketId] = useState("");

  const [imageData, setImageData] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const photoRef = useRef();
  const [label, setLabel] = useState("");
  const [editable, setEditable] = useState(false);
  const [wrongTicket, setWrongTicket] = useState(false);

  useEffect(() => {
    setTicketId(searchParams.get("ticketId").toString());

    const getTicketData = async () => {
      const data = {
        ticketId: searchParams.get("ticketId"),
      };

      const config = {
        headers: { Authorization: process.env.REACT_APP_DOBBY_TOKEN },
      };

      axios
        .post(`${process.env.REACT_APP_API_URL}/getTicket`, data, config)
        .then((res) => {
          if (res.data.vialLabel.S !== "" && res.data.imageUrl.S !== "") {
            setImageUrl(res.data.imageUrl.S);
            setLabel(res.data.vialLabel.S);
            setEditable(false);
          } else {
            setEditable(true);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data.message === "Ticket not found") {
            setWrongTicket(true);
          }
        });
    };
    getTicketData();
  }, []);

  const removeEmojis = (text) => {
    const emojisAndPercent =
      /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff]|%)/g;
    return text.replace(emojisAndPercent, "");
  };

  const onChangeLabel = (text) => {
    setLabel(removeEmojis(text.target.value));
  };

  const saveData = () => {
    if (label.length && imageData !== null) {
      const config = {
        headers: {
          Authorization: process.env.REACT_APP_DOBBY_TOKEN,
        },
      };

      const data = {
        ticketId: ticketId,
        vialLabel: label,
        imageUrl: imageData.replace(/^data:image\/[a-z]+;base64,/, ""),
      };

      // console.log(imageData.replace(/^data:image\/[a-z]+;base64,/, ''));

      axios
        .post(`${process.env.REACT_APP_API_URL}/updateTicket`, data, config)
        .then((res) => {
          console.log(res.data);
          if (res.data) {
            setEditable(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <div className="temporary-qr-container">
      <div className="qr-div" style={{ padding: "20px 0px" }}>
        <div
          style={{
            fontFamily: "Pretendard-Medium",
            fontSize: "16px",
            marginBottom: "5px",
          }}
        >
          RANDOM DIVERSITY 2025 – FRAGRANCE : 音香,
          <br /> The Scent of sound <p />
        </div>
        {/* <QRCode className="qr-image" value={ticketId} /> */}
        <img
          className="poster-image"
          src={poster}
          alt="poster"
          style={{ width: "80%", height: "auto" }}
        />
      </div>
      <div className="ticket-content-conatiner">
        <div>
          <div
            style={{
              fontFamily: "Pretendard-Medium",
              fontSize: "16px",
              marginBottom: "15px",
              textAlign: "center",
              color: "white",
            }}
          >
            {wrongTicket
              ? "유효하지 않은 티켓입니다."
              : "랜덤 다이버시티에 온 것을 환영합니다."}
            <br />
            {editable ? "어떤 사진으로 감정을 추출하시나요?" : null}
            <br />
          </div>
          <div className="image-upload-button">
            {imageData || imageUrl !== "" ? (
              <img
                src={imageData ? imageData : imageUrl}
                className="imageuploaded"
                alt="photo"
              />
            ) : (
              <div className="photo-modal">
                <div
                  id="top-layer"
                  style={{ opacity: 0.5 }}
                  onClick={() => {
                    if (photoRef.current) {
                      downScaleImage(
                        photoRef.current.getImage().toDataURL(),
                        500,
                        0,
                        0
                      ).then((canvas) => {
                        setImageData(canvas.toDataURL());
                      });
                    }
                  }}
                ></div>
                <ProfileSelect type={0} ref={photoRef}></ProfileSelect>
              </div>
            )}
          </div>

          {editable ? (
            <div
              style={{
                fontFamily: "Pretendard-Medium",
                fontSize: "16px",
                marginTop: "15px",
                textAlign: "center",
                color: "white",
              }}
            >
              이미지 업로드 후 체크 표시까지 눌러주세요
            </div>
          ) : null}
        </div>

        {editable ? (
          <div style={{ textAlign: "center", marginTop: "60px" }}>
            <span
              style={{
                fontFamily: "Pretendard-Medium",
                fontSize: "16px",
                marginBottom: "15px",
                color: "white",
              }}
            >
              사진에 어울리는 라벨 이름을 작성해주세요
            </span>
            <br />
            <span
              style={{
                fontFamily: "Pretendard-light",
                fontSize: "16px",
                marginBottom: "15px",
                color: "white",
              }}
            >
              라벨은 프린트되어 사용됩니다.
            </span>
          </div>
        ) : null}

        <div style={{ marginTop: "1rem" }}>
          <input
            style={{ textAlign: "center" }}
            type="text"
            value={label}
            onChange={(e) => onChangeLabel(e)}
            className="label-input"
            maxLength={10}
            editable={editable.toString()}
          />
        </div>
      </div>
      {editable ? (
        <div style={{ marginTop: "30px", width: "95%" }}>
          <div
            style={{
              color: "black",
              fontFamily: "Pretendard-Medium",
              textAlign: "center",
            }}
          >
            데이터 전송 후에는 수정이 불가능합니다
          </div>
          <div className="save-button" onClick={() => saveData()}>
            저장하기
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Hapjeong2025Ticket;
